export class SapAgentUpgrade {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "operationId",
            "baseName": "operationId",
            "type": "string",
            "format": ""
        },
        {
            "name": "phase",
            "baseName": "phase",
            "type": "SapUpgradePhase",
            "format": ""
        },
        {
            "name": "currentVersion",
            "baseName": "currentVersion",
            "type": "string",
            "format": ""
        },
        {
            "name": "previousVersion",
            "baseName": "previousVersion",
            "type": "string",
            "format": ""
        },
        {
            "name": "targetVersion",
            "baseName": "targetVersion",
            "type": "string",
            "format": ""
        },
        {
            "name": "progressPct",
            "baseName": "progressPct",
            "type": "number",
            "format": ""
        },
        {
            "name": "drainRunning",
            "baseName": "drainRunning",
            "type": "number",
            "format": ""
        },
        {
            "name": "drainQueued",
            "baseName": "drainQueued",
            "type": "number",
            "format": ""
        },
        {
            "name": "restartRequired",
            "baseName": "restartRequired",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "error",
            "baseName": "error",
            "type": "string",
            "format": ""
        },
        {
            "name": "updatedAt",
            "baseName": "updatedAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return SapAgentUpgrade.attributeTypeMap;
    }
    constructor() {
    }
}
